import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { RightItem } from '../../rights/rights.component';
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FormArrayFilterPipePipe } from 'src/app/pipes/form-array-filter-pipe.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-dialog-add-rights',
    imports: [
        CommonModule,
        CdkDropList,
        CdkDrag,
        TranslateModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatTooltipModule,
    ],
    templateUrl: './dialog-add-rights.component.html',
    styleUrl: './dialog-add-rights.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogAddRightsComponent implements OnInit {
    public originRightList: Observable<RightItem[]>;
    selectedRights: RightItem[] = [];
    rights: RightItem[] = [];
    listRights: RightItem[] = [];

    searchValue = '';

    constructor(public dialogRef: MatDialogRef<DialogAddRightsComponent>) {}

    ngOnInit() {
        this.originRightList.subscribe((rights) => {
            this.rights = rights;
            this.listRights = rights.slice();
        });
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
    }

    selectAll() {
        this.rights.forEach((a) => {
            this.selectedRights.push(a);
        });

        this.rights.splice(0);
    }

    disableAll() {
        this.selectedRights.forEach((a) => {
            this.rights.push(a);
        });

        this.selectedRights.splice(0);
    }

    search() {
        if (this.searchValue === '') {
            this.rights = this.listRights.filter((a) => !this.selectedRights.includes(a));
        } else {
            this.rights = this.listRights
                .filter((a) => !this.selectedRights.includes(a))
                .filter((a) => a.name.toLowerCase().includes(this.searchValue.toLowerCase()) || a.display.toLowerCase().includes(this.searchValue.toLowerCase()));
        }
    }

    close() {
        this.dialogRef.close(false);
    }

    save() {
        this.dialogRef.close(this.selectedRights);
    }
}
